"use strict";
var IfObservable_1 = require('./IfObservable');
exports._if = IfObservable_1.IfObservable.create;
//# sourceMappingURL=if.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/~/rxjs/observable/if.js
// module id = ../../../../rxjs/observable/if.js
// module chunks = 3